/* global window, document */

(function (window, document) {
    var root = document.getElementById('radar-affidabilita-root');
    if (!root) return;

    function qs(sel, el) { return (el || document).querySelector(sel); }
    function setStatus(msg) { var el = qs('[data-radar-status]', root); if (el) el.textContent = msg || ''; }

    function readFilters() {
        var form = qs('[data-radar-filters]', root);
        if (!form) return {};
        var fd = new FormData(form);
        var out = {};
        var su = fd.get('supplier_uuid');
        if (su != null && String(su).trim() !== '') out.supplier_uuid = String(su).trim();
        return out;
    }

    var apiBase = (root.getAttribute('data-api-base') || '').replace(/\/+$/, '');
    var client = new window.AppaltiMap.ApiGatewayClient({
        baseUrl: apiBase,
        tokenStore: new window.AppaltiMap.TokenStore('appaltimap_auth')
    });

    function getJson(url) {
        var token = client.tokenStore.getToken() || '';
        var headers = { Accept: 'application/json' };
        if (token) headers.Authorization = 'Bearer ' + token;
        return fetch(url, { headers: headers }).then(function (r) { if (!r.ok) throw r; return r.json(); });
    }

    function load() {
        var f = readFilters();
        var outEl = qs('[data-radar-json]', root);
        if (!f.supplier_uuid) { setStatus('Inserisci supplier_uuid.'); return; }
        setStatus('Calcolo…');
        return getJson(apiBase + '/radar/company/' + encodeURIComponent(f.supplier_uuid) + '/reliability')
            .then(function (data) {
                if (outEl) outEl.textContent = JSON.stringify(data, null, 2);
                setStatus('');
            })
            .catch(function () {
                if (outEl) outEl.textContent = '—';
                setStatus('Impossibile calcolare.');
            });
    }

    var form = qs('[data-radar-filters]', root);
    if (form) form.addEventListener('submit', function (e) { e.preventDefault(); load(); });
})(window, document);

